import { Common } from "./Common";

export class Donation extends Common {
    committee_id?: string | null;
    member_id?: string | null;

    purpose: string;
    start_date: Date;
    end_date: Date;
    target_amount?: number | null;
    collected_amount?: number | null;
    remarks?: string | null;
    urls: string;
    rules: string;
    status: string;
    json_details?: any | null;
}
